import { t as e } from "../../../v20240509-JTkMfURM.js";
export { e as dashboardv20240509Client };
